<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-07-14 10:49:02
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-28 14:41:33
-->
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 10:17:48
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 15:27:41
-->
<template>
  <div>
    <a-drawer
      :title="item.id?'编辑报备':'新增报备'"
      :width="'535px'"
      :visible="visible"
      :maskClosable="false"
      @close="close"
    >
      <a-spin :spinning="loadingDeils">
        <div style="padding: 24px">
          <el-tabs v-model="activeName" class="tips-box" type="card" @tab-click="handleClick">
            <el-tab-pane
              :disabled="stagePermissions.indexOf(1) == -1"
              label="第一阶段"
              name="first"
            ></el-tab-pane>
            <el-tab-pane
              :disabled="stagePermissions.indexOf(2) == -1"
              label="第二阶段"
              name="second"
            ></el-tab-pane>
            <el-tab-pane
              :disabled="stagePermissions.indexOf(3) == -1"
              label="第三阶段"
              name="third"
            ></el-tab-pane>
          </el-tabs>
           <div v-show="type == 1" class="title-box">
            <i class="el-icon-info icon-title"></i>
            <div>收到申请后填写第一阶段信息，提交后才可填写下一阶段内容</div>
          </div>
            <div v-show="type == 2" class="title-box">
            <i class="el-icon-info icon-title"></i>
            <div>请按实际情况填报答复有关情况，提交后才可填写下一阶段内容</div>
          </div>
            <div v-show="type == 3" class="title-box">
            <i class="el-icon-info icon-title"></i>
            <div>请按实际情况填报，此阶段内容在指定时间内可进行修改</div>
          </div>
          <div v-show="type == 1">
            <div class="title">
              <div class="icon-title"></div>
              <div class="title-txt">第一阶段</div>
            </div>
            <el-form
              :model="rulesForm"
              :rules="rules"
              ref="collectForm"
              label-width="100px"
              class="demo-ruleForm base_setting"
            >
              <el-form-item label="受理机关" prop="organizationId">
                <!-- <el-select
                  style="width: 100%"
                  :disabled="
                    resData.isApplyReportOneStageEntity &&
                    resData.isApplyReportOneStageEntity.type == 0
                  "
                  v-model="rulesForm.organizationId"
                  placeholder="请选择受理机关"
                  @change="changeJiGuan"
                >
                  <el-option
                    v-for="item in organList"
                    :key="item.mbsOrganizationId"
                    :label="item.organizationName"
                    :value="item.mbsOrganizationId"
                  >
                  </el-option>
                </el-select> -->
                 <a-tree-select
                    v-model="rulesForm.organizationId"
                    style="width: 100%"
                     :disabled="
                        resData.isApplyReportOneStageEntity &&
                        resData.isApplyReportOneStageEntity.type == 0
                      "
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    :tree-data="treeData"
                    @change="changOne"
                    placeholder="请选择受理机关"
                  >
                  </a-tree-select>
              </el-form-item>
              <el-form-item label="申请人姓名" prop="name">
                <el-input
                  :disabled="
                    resData.isApplyReportOneStageEntity &&
                    resData.isApplyReportOneStageEntity.type == 0
                  "
                  maxlength="50"
                  v-model="rulesForm.name"
                  placeholder="多个申请人姓名请用“、”分隔"
                ></el-input>
              </el-form-item>
              <el-form-item label="申请日期" prop="applyTime">
                <el-date-picker
                  :disabled="
                    resData.isApplyReportOneStageEntity &&
                    resData.isApplyReportOneStageEntity.type == 0
                  "
                  style="width: 100%"
                  v-model="rulesForm.applyTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="年/月/日"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="申请事项" prop="shixiang">
                <div>
                  <el-input
                    type="textarea"
                    :rows="4"
                    :disabled="
                      resData.isApplyReportOneStageEntity &&
                      resData.isApplyReportOneStageEntity.type == 0
                    "
                    maxlength="500"
                    v-model="rulesForm.content"
                    placeholder="请描述此项申请的事项内容，或在下方上传申请资料扫描件"
                  ></el-input>
                  <div class="img-box">
                    <el-upload
                      class="upload-demo"
                      :before-upload="(file) => beforeUpload(file)"
                      slot="append"
                      :disabled="
                        resData.isApplyReportOneStageEntity &&
                        resData.isApplyReportOneStageEntity.type == 0
                      "
                      :show-file-list="false"
                      action="#"
                    >
                      <div style="display: flex; align-items: center">
                        <el-button  :disabled="
                        resData.isApplyReportOneStageEntity &&
                        resData.isApplyReportOneStageEntity.type == 0
                      " size="small" type="primary"
                          >附件上传</el-button
                        >
                        <div slot="tip" class="el-upload__tip">
                          可上传附件不超过10个文件
                        </div>
                      </div>
                    </el-upload>
                    <div v-for="(item, index) in fileList">
                      <div class="file-one-box">
                       <div class="text-name"> <i class="ri-file-list-2-line"></i>{{ item.name }}</div>
                        <div
                          v-if="
                            resData.isApplyReportOneStageEntity &&
                            resData.isApplyReportOneStageEntity.type == 0
                          "
                        >
                          <i class="el-icon-close"></i>
                        </div>
                        <div v-else @click="removeImg(index)">
                          <i class="el-icon-close"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item
                v-if="
                  (!resData.isApplyReportOneStageEntity ||
                  resData.isApplyReportOneStageEntity.type != 0) && codeData.indexOf('413') != -1
                "
                prop="information"
              >
                <el-button
                  @click="submitOne"
                  :loading="loadingSubmint"
                  size="medium"
                  type="primary"
                  >保存</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <div v-show="type == 2">
            <div class="title">
              <div class="icon-title"></div>
              <div class="title-txt">第二阶段</div>
            </div>
            <el-form
              :model="rulesFormTwo"
              :rules="rulesTwo"
              ref="collectFormTwo"
              label-width="100px"
              class="demo-ruleForm base_setting"
            >
              <el-form-item label="答复日期" prop="answerTime">
                <el-date-picker
                  style="width: 100%"
                  :disabled="
                    resData.isApplyReportTowStageEntity &&
                    resData.isApplyReportTowStageEntity.type == 0
                  "
                  v-model="rulesFormTwo.answerTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  placeholder="年/月/日"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="处理情况" prop="shixiangTwo">
                <div>
                  <el-input
                    type="textarea"
                    :rows="3"
                    :disabled="
                      resData.isApplyReportTowStageEntity &&
                      resData.isApplyReportTowStageEntity.type == 0
                    "
                    maxlength="500"
                    v-model="rulesFormTwo.content"
                    placeholder="请描述处理政府信息公开申请情况，或在下方上传申请资料扫描件"
                  ></el-input>
                  <div class="img-box">
                    <el-upload
                      class="upload-demo"
                      :before-upload="(file) => beforeUploadTwo(file)"
                      slot="append"
                      :disabled="
                        resData.isApplyReportTowStageEntity &&
                        resData.isApplyReportTowStageEntity.type == 0
                      "
                      :show-file-list="false"
                      action="#"
                    >
                      <div style="display: flex; align-items: center">
                        <el-button :disabled="
                        resData.isApplyReportTowStageEntity &&
                        resData.isApplyReportTowStageEntity.type == 0
                      " size="small" type="primary"
                          >附件上传</el-button
                        >
                        <div slot="tip" class="el-upload__tip">
                          可上传附件不超过10个文件
                        </div>
                      </div>
                    </el-upload>
                    <div v-for="(item, index) in fileListTwo">
                      <div class="file-one-box">
                        <div class="text-name"> <i class="ri-file-list-2-line"></i>{{ item.name }}</div>
                        <div
                          v-if="
                            resData.isApplyReportTowStageEntity &&
                            resData.isApplyReportTowStageEntity.type == 0
                          "
                        >
                          <i class="el-icon-close"></i>
                        </div>
                        <div v-else @click="removeImgTwo(index)">
                          <i class="el-icon-close"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <div class="num-box">
                <el-form-item label="申请人情况" prop="applicatType">
                  <el-select
                    style="width:200px"
                    @change="changeSelect"
                    :disabled="
                      resData.isApplyReportTowStageEntity &&
                      resData.isApplyReportTowStageEntity.type == 0
                    "
                    v-model="rulesFormTwo.applicatType"
                    placeholder="请选择申请人类型"
                  >
                    <el-option
                      v-for="item in [
                        { value: 0, label: '自然人' },
                        { value: 1, label: '商业企业' },
                        { value: 2, label: '科研机构' },
                        { value: 3, label: '社会公益组织' },
                        { value: 4, label: '法律服务机构' },
                        { value: 5, label: '其他' },
                      ]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="applicatNumber">
                  <el-input
                    style="width:100%"
                    v-model="rulesFormTwo.applicatNumber"
                    :disabled="
                      resData.isApplyReportTowStageEntity &&
                      resData.isApplyReportTowStageEntity.type == 0
                    "
                    placeholder="请输入申请人数量"
                  ></el-input>
                </el-form-item>
              </div>
              <el-form-item label="公开方式" prop="openWay">
                <el-select
                  style="width: 100%"
                  :disabled="
                    resData.isApplyReportTowStageEntity &&
                    resData.isApplyReportTowStageEntity.type == 0
                  "
                  v-model="rulesFormTwo.openWay"
                  @change="changeSelect"
                  placeholder="请选择公开方式"
                >
                  <el-option
                    v-for="item in [
                      {
                        value: 0,
                        label: '予以公开',
                      },
                      {
                        value: 1,
                        label: '部分公开',
                      },
                      {
                        value: 2,
                        label: '不予公开',
                      },
                      {
                        value: 3,
                        label: '无法提供',
                      },
                      {
                        value: 4,
                        label: '不予处理',
                      },
                      {
                        value: 5,
                        label: '其他处理',
                      },
                      {
                        value: 6,
                        label: '结转下年度继续办理',
                      },
                    ]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属类型" prop="isApplyReportTowConfigId">
                <el-select
                  style="width: 100%"
                  :disabled="
                    resData.isApplyReportTowStageEntity &&
                    resData.isApplyReportTowStageEntity.type == 0
                  "
                  v-model="rulesFormTwo.isApplyReportTowConfigId"
                  @change="belongToTypeAssemblyFn"
                  placeholder="请选择所属类型"
                >
                  <el-option
                    v-for="item in belongToTypeAssemblyData"
                    :key="item.id"
                    :label="item.belongToWord"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="是否了解申请人意图或信息"
                prop="isApplyIntention"
              >
                <div class="status">
                  <el-radio
                    :disabled="
                      resData.isApplyReportTowStageEntity &&
                      resData.isApplyReportTowStageEntity.type == 0
                    "
                    v-model="rulesFormTwo.isApplyIntention"
                    :label="0"
                    >是</el-radio
                  >
                  <el-radio
                    :disabled="
                      resData.isApplyReportTowStageEntity &&
                      resData.isApplyReportTowStageEntity.type == 0
                    "
                    v-model="rulesFormTwo.isApplyIntention"
                    :label="1"
                    >否</el-radio
                  >
                </div>
              </el-form-item>

              <el-form-item label="申请人意图" :prop="rulesFormTwo.isApplyIntention==0?'applyIntention':''">
                <el-input
                  type="textarea"
                  :rows="3"
                  :disabled="
                    resData.isApplyReportTowStageEntity &&
                    resData.isApplyReportTowStageEntity.type == 0
                  "
                  maxlength="500"
                  v-model="rulesFormTwo.applyIntention"
                  placeholder="请输入申请人意图"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  v-if="
                    (!resData.isApplyReportTowStageEntity ||
                    resData.isApplyReportTowStageEntity.type != 0) && codeData.indexOf('414') != -1
                  "
                  @click="submitTwo"
                  :loading="loadingSubmintTwo"
                  size="medium"
                  type="primary"
                  >保存</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <div v-show="type == 3">
            <div class="title">
              <div class="icon-title"></div>
              <div class="title-txt">第三阶段</div>
            </div>
            <el-form
              :model="rulesFormThree"
              :rules="rulesThree"
              ref="collectFormThree"
              label-width="85px"
              class="demo-ruleForm base_setting"
            >
              <el-form-item label="行政复议" prop="administrativeReviewIds">
                <div>
                  <el-cascader
                    style="width: 100%"
                    v-model="rulesFormThree.administrativeReviewIds"
                    ref="cascaderArr"
                    :disabled="
                      resData.isApplyReportThreeStageEntity &&
                      resData.isApplyReportThreeStageEntity.type == 0
                    "
                    :options="xinZhenData"
                    placeholder="请选择行政复议情况"
                    @change="
                      (value, selectedOptions) => {
                        this.changeXinZhen(value, selectedOptions);
                      }
                    "
                    :props="{ expandTrigger: 'hover' }"
                  ></el-cascader>
                  <div class="text-style">此项提交后60日内可修改</div>
                </div>
              </el-form-item>
              <el-form-item label="行政诉讼" prop="administrativeProceedingIds">
                <div>
                  <el-cascader
                    style="width: 100%"
                    v-model="rulesFormThree.administrativeProceedingIds"
                    ref="cascaderArrTwo"
                    :options="shusongData"
                    placeholder="请选择行政诉讼情况"
                    :disabled="
                      resData.isApplyReportThreeStageEntity &&
                      resData.isApplyReportThreeStageEntity.type == 0
                    "
                    @change="changeShuSong"
                    :props="{ expandTrigger: 'hover' }"
                  ></el-cascader>
                  <div class="text-style">此项提交后180日内可修改</div>
                </div>
              </el-form-item>
              <el-form-item prop="information">
                <el-button
                  v-if="
                    (!resData.isApplyReportThreeStageEntity ||
                    resData.isApplyReportThreeStageEntity.type != 0) && codeData.indexOf('415') != -1
                  "
                  @click="submitThree"
                  :loading="loadingSubmintThree"
                  size="medium"
                  type="primary"
                  >保存</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </a-spin>
    </a-drawer>
  </div>
</template>

<script>
import { uploadImg } from "@/utils/common.js";
import {
  selectList,
  isApplyReportOneStage,
  isApplyReportDeils,
  isApplyReportAdministrativeConfig,
  saveTwo,
  typeList,
  saveThree,
  selectListData
} from "../index";
export default {
  data() {
    return {
      activeName: "first",
      fileList: [],
      fileListTwo: [],
      type: 1,
      rulesForm: {},
      rulesFormTwo: {},
      rulesFormThree: {},
      rules: {
        shixiang: [{ validator: this.reqShixian, trigger: "blur" }],
        applyTime: [
          { required: true, message: "请选择申请日期", trigger: "blur" },
        ],
        organizationId: [
          { required: true, message: "请选择受理机关", trigger: "change,blur" },
        ],
        name: [
          { required: true, message: "请输入申请人姓名", trigger: "blur" },
        ],
      },
      rulesTwo: {
        shixiangTwo: [{ validator: this.reqShixianTwo, trigger: "blur,change" }],
        answerTime: [
          { required: true, message: "请选择答复日期", trigger: "blur" },
        ],
        applicatNumber: [
          { required: true, message: "请输入申请数量", trigger: "blur" },
          { validator: this.numberFn, trigger: "blur" }
        ],

        applicatType: [
          { required: true, message: "请选择申请人情况", trigger: "change,blur" },
        ],
        openWay: [
          { required: true, message: "请选择公开方式", trigger: "change,blur" },
        ],
        isApplyReportTowConfigId: [
          { required: true, message: "请选择所属类型", trigger: "change,blur" },
        ],
        isApplyIntention: [
          { required: true, message: "请选择申请人意图", trigger: "change,blur" },
        ],
        applyIntention: [
          { required: true, message: "请输入申请人意图", trigger: "blur" },
        ],
      },
      rulesThree: {
        administrativeReviewIds: [
          {
            required: true,
            message: "请输入申请人姓名",
            trigger: "change,blur",
          },
        ],
        administrativeProceedingIds: [
          {
            required: true,
            message: "请输入申请人姓名",
            trigger: "change,blur",
          },
        ],
      },
      value: "",
      administrativeReviewIds: [],
      administrativeProceedingIds: [],
      pickerOptions: {},
      options: [
        {
          value: "zhinan",
          label: "指南",
          children: [
            {
              value: "shejiyuanze",
              label: "设计原则",
            },
          ],
        },
      ],
      organList: [],
      loadingSubmint: false,
      loadingSubmintTwo: false,
      loadingSubmintThree: false,
      stagePermissions: [1],
      loadingDeils: false,
      belongToTypeAssemblyData: [],
      xinZhenData: [],
      shusongData: [],
      resData: {},
      codeData:[],
      treeData:[],
    };
  },
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: {},
    },
  },
  mounted() {
     this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  watch: {
    visible(val) {
      this.visibleTwo = val;
      if (this.visibleTwo) {
        this.type = 1;
        this.activeName = 'first';
        this.getShouLiJiGuan();
        if (this.item.id) {
          this.getDeils();
          this.getTypeList();
          this.getTypeListTwo();
        } else {
          // this.$nextTick(()=>{
          //    this.$refs.collectForm.resetFields();
          //     this.$refs.collectFormTwo.resetFields();
          // })
          this.resData = {};
          this.stagePermissions = [1];
          this.isUpdate = 1;
          this.rulesForm = {};
          this.rulesFormTwo = {
             isApplyIntention:0,
          };
          this.rulesFormThree = {};
          this.fileListTwo = [];
          this.fileList = [];
          
        }
      }
    },
  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },
    reqShixian(rule, value, callback) {
      if (!this.rulesForm.content && this.fileList.length == 0) {
        callback(new Error("请填写申请事项"));
      } else {
        callback();
      }
    },
    reqShixianTwo(rule, value, callback){
         if (!this.rulesFormTwo.content && this.fileListTwo.length == 0) {
        callback(new Error("请填写处理情况"));
      } else {
        callback();
      }
    },
    numberFn(rule, value, callback){
        if (/^[1-9]\d*$/.test(value)) {
                callback();
          } else {
            callback(new Error("请填写正整数"));
            
          }
    },
    getTypeList() {
      typeList({
        type: 1,
      }).then((res) => {
        if (res.code == 0) {
          let options = JSON.stringify(res.data)
            .replace(/content/g, "label")
            .replace(/id/g, "value");
          this.shusongData = JSON.parse(options);
        }
      });
    },
    getTypeListTwo() {
      typeList({
        type: 0,
      }).then((res) => {
        if (res.code == 0) {
          let options = JSON.stringify(res.data)
            .replace(/content/g, "label")
            .replace(/id/g, "value");
          this.xinZhenData = JSON.parse(options);
        }
      });
    },
    changOne(value,label){
        this.rulesForm.disposeOffice = label[0];
    },
    getDeils() {
      this.loadingDeils = true;
      isApplyReportDeils({
        id: this.item.id,
      }).then((res) => {
        if (res.code == 0) {
          // 编辑复制
          this.resData = res.data;
          if (res.data.isApplyReportOneStageEntity) {
            this.rulesForm = {
              organizationId:
                res.data.isApplyReportOneStageEntity.organizationId,
              name: res.data.isApplyReportOneStageEntity.name,
              content: res.data.isApplyReportOneStageEntity.content,
              disposeOffice: res.data.isApplyReportOneStageEntity.disposeOffice,
              isApplyReportId: res.data.id,
              accessory: res.data.isApplyReportOneStageEntity.accessory,
              applyTime: res.data.isApplyReportOneStageEntity.applyTime,
            };
            this.fileList = res.data.isApplyReportOneStageEntity.accessory
              ? JSON.parse(res.data.isApplyReportOneStageEntity.accessory)
              : [];
            this.stagePermissions = [1, 2];
            if(res.data && res.data.isApplyReportOneStageEntity && res.data.isApplyReportOneStageEntity.applyTime){
                let _this = this;
                this.pickerOptions = {
                    disabledDate(time) {
                      let nowDate = _this.farmatDate()
                      if(nowDate == res.data.isApplyReportOneStageEntity.applyTime){
                         return time.getTime() < new Date(res.data.isApplyReportOneStageEntity.applyTime).getTime()-3600 * 1000 * 24 * 1
                      }else{
                         return time.getTime() < new Date(res.data.isApplyReportOneStageEntity.applyTime).getTime();
                      }
                     
                    },
                  }
            }
          }else{
            this.rulesForm = {};
          }
          if (res.data.isApplyReportTowStageEntity) {
            this.rulesFormTwo = {
              answerTime: res.data.isApplyReportTowStageEntity.answerTime,
              applicatType: res.data.isApplyReportTowStageEntity.applicatType,
              accessory: res.data.isApplyReportTowStageEntity.accessory,
              applicatNumber:
                res.data.isApplyReportTowStageEntity.applicatNumber,
              belongToType: res.data.isApplyReportTowStageEntity.belongToType,
              belongToTypeAssembly:
                res.data.isApplyReportTowStageEntity.belongToTypeAssembly,
              belongToWord: res.data.isApplyReportTowStageEntity.belongToWord,
              content: res.data.isApplyReportTowStageEntity.content,
              isApplyIntention:
                res.data.isApplyReportTowStageEntity.isApplyIntention,
              isApplyReportId: res.data.id,
              openWay: res.data.isApplyReportTowStageEntity.openWay,
              applyIntention:
                res.data.isApplyReportTowStageEntity.applyIntention,
              isApplyReportTowConfigId: Number(
                res.data.isApplyReportTowStageEntity.isApplyReportTowConfigId
              ),
            };
            this.stagePermissions = [1, 2, 3];
            this.changeSelect();
          }else{
             this.rulesFormTwo = {
               isApplyIntention:0,
             };
          }
          if (res.data.isApplyReportThreeStageEntity) {
            this.rulesFormThree = {
              isApplyReportId: res.data.id,
              administrativeReview:
                res.data.isApplyReportThreeStageEntity.administrativeReview,
              administrativeProceeding:
                res.data.isApplyReportThreeStageEntity.administrativeProceeding,
              administrativeReviewCombination:
                res.data.isApplyReportThreeStageEntity
                  .administrativeReviewCombination,
              administrativeProceedingCombination:
                res.data.isApplyReportThreeStageEntity
                  .administrativeProceedingCombination,
              administrativeReviewIds:
                res.data.isApplyReportThreeStageEntity.administrativeReviewIds
                  .split(",")
                  .map(Number),
              administrativeProceedingIds:
                res.data.isApplyReportThreeStageEntity.administrativeProceedingIds
                  .split(",")
                  .map(Number),
            };
          }else{
              this.rulesFormThree = {};
          }
          this.rulesForm.isApplyReportId = res.data.id;
          this.rulesFormTwo.isApplyReportId = res.data.id;
          this.rulesFormThree.isApplyReportId = res.data.id;
          this.loadingDeils = false;
        }
      });
    },
    farmatDate() {
      var date = new Date();
      var YY = date.getFullYear()
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1);
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + '-' + MM + '-' + DD;
    },
    submitOne() {
      this.rulesForm.accessory =
        this.fileList.length > 0 ? JSON.stringify(this.fileList) : "";
      this.$refs.collectForm.validate((valid) => {
        if (valid) {
          this.loadingSubmint = true;
          isApplyReportOneStage({
            ...this.rulesForm,
            siteId:sessionStorage.getItem('siteId')
          }).then((res) => {
            this.onClose();
            this.loadingSubmint = false;
          });
        }
      });
    },
    
    submitTwo() {
      this.rulesFormTwo.accessory =
        this.fileListTwo.length > 0 ? JSON.stringify(this.fileListTwo) : "";
      this.$refs.collectFormTwo.validate((valid) => {
        if (valid) {
          this.loadingSubmintTwo = true;
          saveTwo({
            ...this.rulesFormTwo,
          }).then((res) => {
            this.onClose();
            this.loadingSubmintTwo = false;
          });
        }
      });
    },
    belongToTypeAssemblyFn(e) {
      for (
        let index = 0;
        index < this.belongToTypeAssemblyData.length;
        index++
      ) {
        const element = this.belongToTypeAssemblyData[index];
        if (element.id == e) {
          this.rulesFormTwo.belongToTypeAssembly = element.belongToTypeAssembly;
          this.rulesFormTwo.belongToType = element.belongToType;
          this.rulesFormTwo.belongToWord = element.belongToWord;
        }
      }
    },
    getShouLiJiGuan() {
      this.loadingDeils = true;
      selectListData({}).then((res) => {
        if (res.code == 0) {
           let options = JSON.stringify(res.data)
                        .replace(/organizationName/g, "title")
                        .replace(/id/g, "value");
              this.treeData = JSON.parse(options)
               this.loadingDeils = false;
        }
      });
    },
    changeJiGuan(e) {
      for (let index = 0; index < this.organList.length; index++) {
        const element = this.organList[index];
        if (e == element.mbsOrganizationId) {
          this.rulesForm.disposeOffice = element.organizationName;
        }
      }
    },
    changeSelect() {
      delete this.rulesFormTwo.isApplyReportTowConfigId;
      isApplyReportAdministrativeConfig({
        applicatType: this.rulesFormTwo.applicatType,
        openWay: this.rulesFormTwo.openWay,
      }).then((res) => {
        if (res.code == 0) {
          this.belongToTypeAssemblyData = res.data;
        }
      });
    },
    changeXinZhen(e) {
      const checkedNode = this.$refs["cascaderArr"].getCheckedNodes();
      this.rulesFormThree.administrativeReviewCombination =
        checkedNode[0].data.combination;
      this.rulesFormThree.administrativeReview =
        checkedNode[0].pathLabels.join("/");
    },
    changeShuSong() {
      const checkedNode = this.$refs["cascaderArrTwo"].getCheckedNodes();
      this.rulesFormThree.administrativeProceedingCombination =
        checkedNode[0].data.combination;
      this.rulesFormThree.administrativeProceeding =
        checkedNode[0].pathLabels.join("/");
    },
    submitThree() {
      this.$refs.collectFormThree.validate((valid) => {
        if (valid) {
          this.rulesFormThree.administrativeReviewIds =
            this.rulesFormThree.administrativeReviewIds.join(",");
          this.rulesFormThree.administrativeProceedingIds =
            this.rulesFormThree.administrativeProceedingIds.join(",");
            this.loadingSubmintThree = true;
          saveThree({
            ...this.rulesFormThree,
          }).then((res) => {
            this.onClose();
            this.loadingSubmintThree = false;
          });
        }
      });
    },
    close() {
      this.$emit("close");
    },
    beforeUpload(file) {
      if (this.fileList.length >= 10) {
        this.$message.error("最多上传十个附件");
        return;
      }
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      // 支持office文档格式和zip
      if (["pdf", "docx", "xlsx","zip","rar","xls","doc","ppt","pptx","png","jpg","jpeg"].indexOf(fileSuffix) == -1) {
        this.$message.error("请上传 pdf、docx、xlsx、zip、rar、xls、xlsx、doc、ppt、pptx、png、jpg、jpeg 格式!");
        return;
      }
      this.loadingDeils = true;
      uploadImg(file, "site_setting").then((res) => {
        this.fileList.push({ url: res.path, name: res.name });
        this.loadingDeils = false;
      });
      return false;
    },
    beforeUploadTwo(file) {
      if (this.fileListTwo.length >= 10) {
        this.$message.error("最多上传十个附件");
        return;
      }
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (["pdf", "docx", "xlsx","zip","rar","xls","doc","ppt","pptx","png","jpg","jpeg"].indexOf(fileSuffix) == -1) {
        this.$message.error("请上传 pdf、docx、xlsx、zip、rar、xls、xlsx、doc、ppt、pptx、png、jpg、jpeg  格式!");
        return;
      }
       this.loadingDeils = true;
      uploadImg(file, "site_setting").then((res) => {
        this.fileListTwo.push({ url: res.path, name: res.name });
         this.loadingDeils = false;
      });
      return false;
    },
    removeImgTwo(index) {
      this.fileListTwo.splice(index, 1);
    },
    removeImg(index) {
      this.fileList.splice(index, 1);
    },
    handleClick(e) {
      if (this.activeName == "first") {
        this.type = 1;
      }
      if (this.activeName == "second") {
        this.type = 2;
      }
      if (this.activeName == "third") {
        this.type = 3;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #f4f4f6 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .search {
    display: flex;
  }
  .back {
    font-size: 18px;
    font-weight: 600;
    color: #000;
  }
  .add-img {
    margin-right: 5px;
    margin-top: -3px;
    cursor: pointer;
  }
}
.log-box {
  //border-bottom: solid 1px #dcdfe6;
  display: flex;
  margin-left: 24px;
  margin-right: 24px;
  margin-top: 24px;
  .log {
    padding: 10px 20px;
    border-top: solid 1px #dcdfe6;
    border-left: solid 1px #dcdfe6;
    cursor: pointer;
    border-bottom: solid 1px #dcdfe6;
  }
  .log:last-child {
    border-right: solid 1px #dcdfe6;
    border-top-right-radius: 10px;
  }
  .log:first-child {
    border-top-left-radius: 10px;
  }
}
.dir {
  height: 1px;
  background: #dcdfe6;
  margin-left: 409px;
  margin-right: 24px;
  margin-top: -1px;
}
.status {
  border: solid 1px #dcdfe6;
  border-radius: 4px;
  padding-left: 10px;
}
/deep/ .el-radio__inner::after {
  width: 8px;
  height: 8px;
}
/deep/ .el-radio__inner {
  width: 16px;
  height: 16px;
}
/deep/ .ant-select-selection--single {
  height: 44px;
}
/deep/ .ant-select-selection__rendered {
  line-height: 38px;
  display: flex;
  align-items: center;
}
.choose_template {
  /deep/.el-dialog__title {
    font-size: 18px;
    font-weight: bold;
  }
  /deep/ .el-dialog__body {
    padding-top: 10px;
  }
  /deep/ .el-dialog__close {
    font-weight: 600;
  }
  /deep/.el-dialog {
    width: 36%;
  }
  .lod-tips {
    background: #f7f7f7;
    font-size: 12px;
    color: #928f8f;
    line-height: 36px;
    padding: 0 10px;
    border-radius: 4px;
  }
  .choose-path {
    line-height: 50px;
    padding: 0 10px;
    border-radius: 4px;
    border: solid 1px #dcdfe6;
    margin-top: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .template-list {
    border: solid 1px #dcdfe6;
    border-radius: 4px;
    margin-top: 20px;
    .list-box {
      height: 450px;
      overflow-y: auto;
    }
    .title {
      background: #f7f7f7;
    }
    .item {
      font-weight: bold;
      line-height: 52px;
      box-sizing: border-box;
      border-bottom: solid 1px #dcdfe6;
      padding: 0 10px;
      cursor: pointer;
      &:last-child {
        border: none;
      }
    }
  }
}
/deep/ .icon-arrow-back:before {
  font-size: 20px;
}
.lod-box {
  display: flex;
  align-items: center;
}
.back-box {
  margin-right: 10px;
  cursor: pointer;
}
.base_seting {
  overflow-y: auto;
  padding: 24px;
  max-width: 800px;
}
.delete-btn {
  position: absolute;
  margin-left: 10px;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  margin-bottom: 20px;
}
.column-box {
  .tree-box {
    max-height: 450px;
    overflow-y: auto;
    background: #f8f9fa;
  }
  /deep/.el-dialog__footer {
    padding-top: -5px;
  }
}
/deep/ .edui-default .edui-editor-toolbarbox {
  position: sticky;
  top: -10px;
  z-index: 9999;
}

/deep/ .edui-default .edui-editor-iframeholder,
.edui-default .edui-editor-iframeholder iframe {
  height: 360px !important;
}
/deep/ .ant-drawer-title {
  font-weight: 600;
  font-size: 18px;
}
/deep/.ant-form-item-label {
  width: 121px;
}
/deep/ .ant-form-item {
  display: flex;
}
/deep/ .ant-form-item-control-wrapper {
  width: 100%;
}
.btn-box {
  margin-top: 24px;
  margin-left: 102px;
}
.el-button--primary {
  background: #176de6;
}
.change-model {
  width: calc(100% - 110px);
}
@media screen and (max-width: 720px) {
  .log-box {
    margin-left: 0px !important;
    margin-right: 0px !important;
    margin-top: 0px !important;
  }
  .form {
    width: 100% !important;
    margin-top: 20px;
  }
  .base_seting {
    padding: 0px !important;
    padding-right: 15px !important;
  }
  .demo-ruleForm {
    height: 50vh !important;
  }
  /deep/ .change-model {
    width: auto;
  }
  .choose_template .template-list .list-box {
    height: 45vh !important;
  }
  /deep/ .ant-form-item-label {
    width: 48%;
    text-align: center;
  }
}
.title-box {
  display: flex;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding: 8px 10px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  margin-bottom: 20px;
  font-family: HarmonyOS_Sans_SC-regular;
  .icon-title {
    color: #a9aab1;
    transform: rotate(-13deg);
    margin-top: 3px;
    margin-right: 2px;
  }
  /deep/ .anticon-close {
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
    font-weight: bold;
  }
}
/deep/ .el-form-item__label {
  text-align: left;
}
.bottom {
  text-align: right;
  position: absolute;
  bottom: 0;
  border-top: solid 1px #e5e7ec;
  width: 100%;
  background: #fff;
  z-index: 9999999999999;
  .form-bottom {
    margin-right: 24px;
    padding: 15px 0px;
  }
}
/deep/ .ant-drawer-body {
  padding: 0px !important;
}
/deep/.ant-drawer-content {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
/deep/ .el-input-group__append,
.el-input-group__prepend {
  border-radius: 0px 4px 4px 0px;
  background-color: rgba(24, 109, 230, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
}
.file-box {
  /deep/ .el-input__inner {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-right: none !important;
  }
}
/deep/ .ant-select-selection--multiple .ant-select-selection__choice {
  float: left;
  max-width: 100%;
  margin-right: 4px;
  padding: 0 20px 0 10px;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.65);
  background: none;
  border: none;
  border-radius: none;
  cursor: default;
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.drop-box {
  width: 331px;
}
/deep/ .ant-select-selection--single{
  height: 40px;
}
/deep/ .el-input__prefix {
  left: auto;
  right: 5px;
}
/deep/.el-input--prefix .el-input__inner {
  padding-left: 15px;
}
.upload-demo {
  .el-button--primary {
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    text-align: center;
    font-family: Microsoft Yahei;
    width: 80px;
    height: 32px;
  }
  /deep/ .el-upload {
    text-align: left;
  }
  /deep/ .el-icon-close {
    font-size: 16px;
    color: rgba(144, 147, 153, 1);
    margin-top: 7px;
  }
  .el-upload__tip {
    margin-top: 0px;
    margin-left: 6px;
  }
}
.file-one-box {
  height: 26px;
  line-height: 20px;
  background-color: rgba(255, 255, 255, 1);
  color: rgba(96, 98, 102, 1);
  font-size: 14px;
  text-align: left;
  font-family: Roboto;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  padding: 0 5px;
  justify-content: space-between;
}
.file-one-box:hover {
  background-color: rgba(245, 247, 250, 1);
}
.img-box {
  border-radius: 0px 0px 4px 4px;
  text-align: left;
  border: 1px solid rgba(220, 223, 230, 1);
  padding: 4px 10px;
  border-top: none;
}
.title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 5px;
  .icon-title {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background-color: rgba(23, 109, 230, 1);
  }
  .title-txt {
    color: rgba(23, 109, 230, 1);
    font-size: 16px;
    font-family: HarmonyOS_Sans_SC-regular;
    margin-left: 10px;
    font-weight: 600;
  }
}
.sheng-qing {
  display: flex;
}
/deep/ .el-form-item:nth-child(6) {
  .el-form-item__label {
    line-height: 15px;
    width: 110px !important;
  }
  .el-form-item__content {
    margin-left: 110px !important;
  }
}
/deep/ .el-form-item:nth-child(3) {
  .el-input__inner {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
}
.shengqing-num {
  height: 40px;
  border-radius: 0px 4px 4px 0px;
  color: rgba(144, 147, 153, 1);
  font-size: 14px;
  text-align: left;
  font-family: Microsoft Yahei;
  border: 1px solid rgba(220, 223, 230, 1);
  line-height: 40px;
  flex: 1;
  border-left: none;
  padding-left: 6px;
}
.text-style {
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  font-family: Roboto-regular;
}
.num-box {
  display: flex;
  /deep/ .el-form-item:first-child {
    .el-form-item__content {
      .el-input__inner {
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
      }
    }
  }
  /deep/ .el-form-item:last-child {
    .el-form-item__content {
      margin-left: 0px !important;
      .el-input__inner {
        border-left: none;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
      }
    }
  }
}
.text-name{
  color: rgba(96, 98, 102, 1);
  font-size: 12px;
  font-family: SourceHanSansSC-regular;
}
.tips-box{
  /deep/ .is-disabled{
  color: rgba(102, 111, 128, 1);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
  background-color: rgba(224, 224, 224, 0.5);
}
}
/deep/ .el-tabs__header{
  margin: 0 0 20px;
}

</style>
